angular.module( 'acme.view.application.membership.categories.create.rules', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.categories.create.rules.controllers'
])

.config(function config( $stateProvider ) {

  var membershipCategoriesCreateRules = {
    name: 'application.membership.categories.create.rules',
    url: '/rules',
    views: {
      "subview-main": {
        controller: 'MembershipCategoriesCreateRulesController',
        templateUrl: 'views/application/views/membership/categories/create/rules/rules.tpl.html'
      }
    },
    data: {
      pageTitle: 'Create Membership Level'
    }
  },
  membershipCategoriesEditRules = {
    name: 'application.membership.categories.edit.rules',
    url: '/rules',
    views: {
      "subview-main": {
        controller: 'MembershipCategoriesCreateRulesController',
        templateUrl: 'views/application/views/membership/categories/create/rules/rules.tpl.html'
      }
    },
    data: {
      pageTitle: 'Edit Membership Level'
    }
  };
    $stateProvider
      .state(membershipCategoriesCreateRules)
      .state(membershipCategoriesEditRules);
});
